import { render, staticRenderFns } from "./ou_edit.vue?vue&type=template&id=c1b52ab8&scoped=true"
import script from "./ou_edit.vue?vue&type=script&lang=ts"
export * from "./ou_edit.vue?vue&type=script&lang=ts"
import style0 from "./ou_edit.vue?vue&type=style&index=0&id=c1b52ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b52ab8",
  null
  
)

export default component.exports